import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, finalize, Observable, shareReplay, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { UserStore } from '../store/user.store';
import { AUTH_CALLBACK_ROUTE } from '../../app.routes';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private router = inject(Router);
  private httpClient = inject(HttpClient);
  private userStore = inject(UserStore);
  private refreshTokenInProgress$: Observable<any> | null = null;

  public login(): void {
    const currentUrl = this.router.url;

    const hompageDestination = currentUrl === '/login' ? '/pns' : currentUrl;
    localStorage.setItem('returnUrl', hompageDestination);

    const origin = window.location.origin;
    const redirectUrl = `${origin}/${AUTH_CALLBACK_ROUTE}`;
    const googleAuthUrl = `${environment.authBaseUrl}/oauth2/authorization/google?redirect_url=${encodeURIComponent(redirectUrl)}`;

    window.location.assign(googleAuthUrl);
  }

  public logout(): void {
    this.httpClient
      .post(`${environment.baseApiUrl}/api/authentication/sign-out`, {})
      .pipe(
        tap({
          next: () => {
            this.clearState();
          },
          error: (error) => {
            console.error('[AuthService]: Errore durante il logout sul server.', error);
            this.clearState();
          },
        }),
      )
      .subscribe();
  }

  public clearState(): void {
    this.userStore.clear();
    localStorage.removeItem('returnUrl');
    this.router.navigate(['/login']);
  }

  public refresh(): Observable<any> {
    if (!this.refreshTokenInProgress$) {
      this.refreshTokenInProgress$ = this.httpClient
        .post(`${environment.baseApiUrl}/api/authentication/sign-in/refresh`, {})
        .pipe(
          shareReplay(1),
          finalize(() => {
            this.refreshTokenInProgress$ = null;
          }),
          catchError((err) => {
            this.logout();
            return throwError(() => err);
          }),
        );
    }

    return this.refreshTokenInProgress$;
  }
}
